module.exports = __webpack_public_path__ + "static/media/amaia-typing-indicator.44ad9b8d.gif";